<template>
    <v-select
        v-model="selectedAgent"
        class="order-details-edit-agent"
        hide-details
        :loading="agentLoading || saveLoading"
        :disabled="agentLoading || saveLoading"
        variant="outlined"
        return-object
        density="compact"
        :items="persons"
        :item-title="getItemText"
        @update:model-value="save"
    />
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrderDetailsEditAgent extends Vue {
        @Prop({required: true}) companyId
        @Prop({required: true}) agentId
        @Prop({required: true}) saveLoading

        agentLoading = false
        persons = []
        selectedAgent = null

        async mounted() {
            await this.load()
        }

        async load() {
            this.agentLoading = true
            try {
                this.persons = (await this.$api.persons.get({companyId: this.companyId}))['users']?.sort((a, b) =>
                    a.lastName && b.lastName ? a.lastName.localeCompare(b.lastName) : -1
                )
                this.selectedAgent = this.persons.find(p => p.personId === this.agentId)
                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.agentLoading = false
            }
        }

        @Emit()
        save() {
            return {
                firstName: this.selectedAgent.firstName,
                lastName: this.selectedAgent.lastName,
                prefix: this.selectedAgent.prefix,
                id: this.selectedAgent.personId,
            }
        }

        getItemText(user) {
            return `${user.prefix || ''} ${user.firstName || ''} ${user.lastName || ''} ${
                user.email ? '(' + user.email + ')' : ''
            }`
        }
    }

    export default OrderDetailsEditAgent
</script>
